import { times, divide, minus } from 'number-precision'
import { calculateOdds, getPrecision } from 'utils/common-functions/index'
import { MAX_MINE_COUNT, MAX_TILE_COUNT } from '../../GongaMineGame/mineGame.constants'

export const mines = Array.from({ length: MAX_MINE_COUNT }, (_, i) => i + 1)

export const calculateMineGameCashoutOdds = (mineCount = 0, openedTileCount = 0, gameSettings) => {
  let combinedOdds = 1
  for (let index = 0; index < openedTileCount; index++) {
    const probability = divide(1, divide((minus(minus(MAX_TILE_COUNT, mineCount), index)), minus(MAX_TILE_COUNT, index)))
    combinedOdds = times(combinedOdds, probability)
  }
  return calculateOdds({ odds: combinedOdds, ...gameSettings })
}

export const getAllCalculatedMineGameOdds = (mineCount = 0, openedTileCount = 0, gameSettings) => {
  const multipliers = []
  let combinedOdds = 1

  for (let index = 0; index < openedTileCount; index++) {
    const probability = divide(1, divide((minus(minus(MAX_TILE_COUNT, mineCount), index)), minus(MAX_TILE_COUNT, index)))
    combinedOdds = times(combinedOdds, probability)
    multipliers.push(calculateOdds({ odds: combinedOdds, ...gameSettings }))
  }

  return multipliers
}

export const generateRandomResult = (mineCount) => {
  // list of number of tiles in mine game
  const mines = Array.from({ length: 25 }, (_, index) => index + 1)
  // shuffle list
  for (let i = mines.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [mines[i], mines[j]] = [mines[j], mines[i]]
  }

  return mines.slice(0, mineCount)
}
